module.exports = __webpack_public_path__ + "static/media/img-cabd19f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/community-wallpaper.png
// module id = 2286
// module chunks = 39